/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from "react";
import { useAtom, useAtomValue, atom, useSetAtom } from "jotai";
import styled from "styled-components";
import anime from "animejs/lib/anime.es.js";
import {
  appData,
  continuekStore,
  continueData,
  appActiveCount,
  bgmState,
} from "@stores/bookdata";
import { settingState } from "@stores/modal";
import playSound from "@/sound";
import MainSideBar from "@components/elements/MainSideBar";
import ContinueBox from "@components/ContinueBox";
import BookMarkBox from "@components/BookMarkBox";
import StepBox from "@components/StepBox";
import MainNoti from "@components/MainNoti";
import MainNotiBadge from "@components/MainNotiBadge";
import { randomRange, currentPageState } from "@stores/vars";
import { trialService } from "@/data/data";

const Wrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
const MainBackground = styled.div`
  position: absolute;
  width: 100%;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #122546;
    opacity: 0.9;
  }
  > img {
    transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
    position: relative;
    width: 100%;
  }
`;

const MainVerticalScrollContainer = styled.div`
  position: relative;
  height: calc(1200px - 315px);
  padding-top: 175px;
  padding-left: 230px;
  overflow-x: hidden;
  overflow-y: auto;
  top: 140px;
  -webkit-mask-image: linear-gradient(
      to bottom,
      transparent,
      rgba(255, 255, 255, 1.99)
    ),
    linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1.99)),
    linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1.99)),
    linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1.99)),
    linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1.99)),
    linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1.99));
`;

const Logo = styled.div`
  position: absolute;
  width: 370px;
  height: 67px;
  left: 55px;
  top: 70px;
  background: url(${require("@assets/img/logo.png")}) no-repeat;

  &.trg {
    background: url(${require("@assets/img/logo2.png")}) no-repeat;
  }
`;

const SettingButton = styled.button`
  position: absolute;
  left: 50px;
  bottom: 30px;
  width: 61px;
  height: 61px;
  display: inline-block;
  background: url(${require("@assets/img/setting_icon.png")});
  opacity: 0.5;
`;

const introPlay = atom(true);
const ranBg = [
  require("@data/assets/_static/bg1.jpg"),
  require("@data/assets/_static/bg2.jpg"),
  require("@data/assets/_static/bg3.jpg"),
  require("@data/assets/_static/bg4.jpg"),
  require("@data/assets/_static/bg5.jpg"),
  require("@data/assets/_static/bg6.jpg"),
  require("@data/assets/_static/bg7.jpg"),
  require("@data/assets/_static/bg8.jpg"),
  require("@data/assets/_static/bg9.jpg"),
  require("@data/assets/_static/bg10.jpg"),
  require("@data/assets/_static/bg11.jpg"),
  require("@data/assets/_static/bg12.jpg"),
  require("@data/assets/_static/bg13.jpg"),
  require("@data/assets/_static/bg14.jpg"),
  require("@data/assets/_static/bg15.jpg"),
  require("@data/assets/_static/bg16.jpg"),
  require("@data/assets/_static/bg17.jpg"),
  require("@data/assets/_static/bg18.jpg"),
  require("@data/assets/_static/bg19.jpg"),
  require("@data/assets/_static/bg20.jpg"),
  require("@data/assets/_static/bg21.jpg"),
];

const BGUrl = ranBg[randomRange(0, ranBg.length - 1)];

const Main = () => {
  const [isIntroPlay, setIntroPlay] = useAtom(introPlay);
  const setCurrentPage = useSetAtom(currentPageState);
  const continuedata = useAtomValue(continuekStore);
  const setContinue = useSetAtom(continueData);
  const [dCount, setDCount] = useAtom(appActiveCount);
  const setSetting = useSetAtom(settingState);
  const isBgm = useAtomValue(bgmState);
  const data = useAtomValue(appData);
  const isTr = trialService;

  const refData = {
    scWrap: null,
    scImg: null,
    scHeight: 0,
    imgHeight: 0,
  };

  const openSettingPop = () => {
    setSetting({
      show: true,
    });
  };

  useEffect(() => {
    window.__bgmVolume = isBgm;
    setCurrentPage("main");
    playSound.bgm(require("@assets/sounds/bgm/main.mp3"));
    refData.scImg = document.querySelector("#scImg");
    refData.scWrap = document.querySelector("#scWrap");
    refData.scImg.onload = function () {
      refData.scHeight = refData.scWrap.scrollHeight - 1200;
      refData.imgHeight = refData.scImg.offsetHeight - 1400;
      refData.scImg.onload = null;
    };
  }, []);

  // 페럴럭스 스크롤
  const onScroll = useCallback((event) => {
    const scPer = event.target.scrollTop / refData.scHeight;
    const resultY = refData.imgHeight * scPer;
    refData.scImg.style.transform = `translateY(${-resultY}px)`;
  }, []);

  const inNoti = () => {
    setDCount(dCount + 1);
    const actorBadge = document.querySelector("#notificationBadge");
    anime({
      targets: actorBadge,
      scale: [0.6, 1],
      opacity: [0, 1],
      complete: () => {
        anime({
          targets: document.querySelector("#notificationBox"),
          translateX: [30, 0],
          opacity: [0, 1],
          duration: 300,
          easing: "easeOutQuad",
        });
      },
    });
  };

  useEffect(() => {
    inNoti();
    if (continuedata) {
      const key = continuedata.bookKey;
      const momKey = key.split("-")[0];
      const newData = [...data.studybooks].filter(
        (data) => data.categoryKey === momKey
      )[0];
      if (newData) {
        const _continue = newData.books.filter((d) => d.key === key)[0];
        setContinue(_continue);
      }
    } else {
      setContinue(null);
    }
    return () => {
      playSound.bgm(null);
      const actorBadge = document.querySelector("#notificationBadge");
      anime.remove(actorBadge);
    };
  }, []);

  return (
    <Wrap id="mainWrap">
      <MainBackground>
        <img src={BGUrl} alt="" id="scImg" />
      </MainBackground>
      <Logo className={isTr === true ? "trg" : ""} />
      <MainVerticalScrollContainer onScroll={onScroll} id="scWrap">
        <ContinueBox continuePage={continuedata && continuedata.page} />
        <BookMarkBox />
        {data.studybooks.map((d, i) => {
          return (
            <StepBox
              id={`sbox${i}`}
              cName={`sbox${i}`}
              key={i}
              category={d.category}
              badge={d.badge}
              desc={d.desc}
              color={d.color}
              books={d.books}
            />
          );
        })}
      </MainVerticalScrollContainer>
      <MainSideBar />
      <SettingButton onClick={openSettingPop} />
      <MainNotiBadge vCount={dCount} />
      {isIntroPlay && (
        <MainNoti
          onEnd={() => {
            setIntroPlay(false);
          }}
          onClick={() => {
            setIntroPlay(false);
          }}
        ></MainNoti>
      )}
    </Wrap>
  );
};

export default React.memo(Main);
